import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'
import {
  IconButton as MaterialIconButton,
  AppBar as MaterialAppBar,
} from '@material-ui/core'

export const AppBar = styled(MaterialAppBar)`
  background-color: #04bfe7;
  box-shadow: none;
  height: 50px;
`

export const HeaderSpace = styled.div`
  ${mq({
    padding: ['30px', '30px', '60px'],
  })}
`

export const IconButton = styled(MaterialIconButton)`
  ${mq({
    display: ['block', 'block', 'none'],
  })}
`

export const Desktop = styled.div`
  background-color: #fff;
  border-bottom: solid 2px #eef1f6;
  padding: 25px 0 0;
  text-align: center;
  margin-top: 35px;
  position: fixed;
  width: 100%;
  z-index: 100;

  ${mq({
    display: ['none', 'none', 'block'],
  })}
`

export const DrawerContent = styled.div`
  min-width: 200px;
`
